<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :search-data="searchData"
      :headers="headers"
      :items="manualRechargeList.items"
      :paginate="paginateConfig"
      :total-count="manualRechargeList.totalCount"
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
    />

    <material-dialog
      :visible="confirmDialog"
      :title="$t('Views.Finance.sureCancelRecharge')"
      width="500"
      @cancleFn="handleCloseDialog"
      @confirmFn="handleSubmitDialog"
    >
      <template>
        <div
          class="print-footer"
          style="width:100%;"
        >
          <div>
            <label class="print-item-title">{{ $t("Views.Finance.client") }}</label><label>：</label>
            <label class="print-item-full-value">{{ rechargeDetail && rechargeDetail.customer ? rechargeDetail.customer.name : "" }}</label>
          </div>

          <div>
            <label class="print-item-title">{{ $t("Views.Finance.account") }}</label><label>：</label>
            <label class="print-item-full-value">{{ rechargeDetail ? getAccountName(rechargeDetail.accountName) : "" }}</label>
          </div>

          <div>
            <label class="print-item-title">{{ $t("Views.Finance.recharge_method") }}</label><label>：</label>
            <label class="print-item-full-value">{{ rechargeDetail ? rechargeDetail.paymentMethodName : "" }}</label>
          </div>

          <div>
            <label class="print-item-title">{{ $t("Views.Finance.rechargeAmount") }}</label><label>：</label>
            <label class="print-item-full-value">{{ rechargeDetail ? $util.data.moneyFmt(rechargeDetail.amount, rechargeDetail.accountName) : "" }}</label>
          </div>

          <div>
            <label class="print-item-title">{{ $t("Views.Finance.dateTime") }}</label><label>：</label>
            <label class="print-item-full-value">
              {{ rechargeDetail.operateTime | dateFmt }}
            </label>
          </div>
          <div>
            <label class="print-item-title">{{ $t("Views.Finance.remark") }}</label><label>：</label>
            <label class="print-item-full-value">{{ rechargeDetail ? rechargeDetail.remark : "" }}</label>
          </div>
        </div>
      </template>
    </material-dialog>

    <material-dialog
      :visible="showDialog"
      :disable-btn="!enableSubmitButton"
      :title="$t('Views.Finance.sure')"
      width="500"
      @cancleFn="handleCloseDialog('confirm')"
      @confirmFn="handleSubmitDialog('confirm')"
    >
      <template>
        <div class="is-required">
          <v-form ref="undoReasonForm">
            <v-textarea
              v-model="undoReason"
              :rules="undoReasonRules"
              counter
              maxlength="50"
              :label="$t('Views.Finance.cancelDesc')"
            />
          </v-form>
        </div>
      </template>
    </material-dialog>

  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import { format } from 'date-fns'
export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      headers: [
        // {
        //   text: $t('Views.Finance.customer_search_label'),
        //   value: 'customerInfo',
        //   width: 180,
        //   align: 'left',
        //   renderHeader: (h, params) => {
        //     return h(
        //       'div',
        //       {
        //         domProps: {
        //           innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.customerNum')
        //         }
        //       }
        //     )
        //   },
        //   render: (h, param) => {
        //     const text = param.row.customer.name + (param.row.customer.serialNumber ? '<br />' + param.row.customer.serialNumber : '')
        //     return h('div', {
        //       domProps: {
        //         innerHTML: text
        //       }
        //     })
        //   }
        // },
        { // 新客户编码
          text: $t('Views.Finance.customer_search_label'),
          value: 'customerInfo',
          width: 180,
          align: 'left',
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                domProps: {
                  innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.newCustomerNumList')
                }
              })
          },
          render: (h, param) => {
            const text = param.row.customer ? param.row.customer.name + (param.row.customer.newSerialNumber && param.row.customer.serialNumber ? '<br />' +
              param.row.customer.newSerialNumber : param.row.customer.newSerialNumber ? '<br />' + param.row.customer.newSerialNumber : '<br />' + param.row.customer.serialNumber) : '--'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          text: $t('Views.Finance.dateTime'),
          value: 'operateTime',
          type: 'date'
        },
        {
          text: $t('Views.Finance.recharge_method'),
          value: 'paymentMethodName'
        },
        {
          text: $t('Views.Finance.rechargeAmount'),
          value: 'amount',
          width: 120,
          render: (h, params) => {
            return h(
              'div',
              this.$util.data.moneyFmt(params.row['amount'], params.row.accountName)
            )
          }
        },
        {
          text: $t('Views.Finance.account'),
          value: 'accountName',
          render: (h, params) => {
            return h('div', ENUMS.systemAccountNames[params.row.accountName])
          },
          width: 140
        },
        {
          text: $t('Views.Finance.remark'),
          value: 'remark',
          width: 300
        },
        {
          text: $t('Views.Finance.rechargeMan'),
          value: 'operateName',
          width: 120
        },
        {
          text: $t('Views.Finance.status'),
          value: 'status',
          render: (h, params) => {
            return h(
              'div',
              {
                style: { color: ENUMS.ManualRechargeStatus[params.row.status].color },
                class: 'status'
              },
              ENUMS.ManualRechargeStatus[params.row.status].text
            )
          }
        },
        {
          text: $t('Views.Finance.action'),
          value: 'action',
          actions: [
            {
              // 撤销
              text: this.$t('Views.Finance.cancel'),
              color: this.$store.state.app.cancelBtnColor,
              visible: row => {
                return this.getPermission('FinanceManager.RechargeList.Undo') && row.row.status === 'Pass'
              },
              actionFn: row => {
                this.rechargeDetail = row.row
                this.confirmDialog = true
              }
            }
          ]
        }
      ],
      searchData: [
        {
          key: 'customerFilter',
          value: '',
          label: $t('Views.Finance.customer_search_label'),
          placeholder: $t('Views.Finance.nameOrSN')
        },
        {
          key: 'rechargeTime',
          label: $t('Views.Finance.dateTime'),
          value: '',
          type: 'date',
          icon: 'mdi-calendar',
          maxDate: format(new Date(), 'YYYY-MM-DD')
        },
        {
          key: 'accountId',
          name: $t('Views.Finance.accountName'),
          placeholder: $t('Views.Finance.selectAccount'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          id: '',
          state: []
        },
        {
          key: 'operatorId',
          id: '',
          name: $t('Views.Finance.rechargeMan'),
          placeholder: $t('Views.Finance.rechargeManPlaceholder'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          state: []
        },
        {
          key: 'isSuccessed',
          value: '',
          label: $t('Views.Finance.status'),
          placeholder: $t('Views.Goods.allStatus'),
          type: 'select',
          state: [
            {
              value: true,
              label: $t('Views.Finance.successRecharge')
            },
            {
              value: false,
              label: $t('Views.Finance.canceled')
            }
          ]
        }
      ],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        customerFilter: '',
        operatorId: '',
        accountId: '',
        isSuccessed: '',
        rechargeTime: '',
        skipCount: 0,
        maxResultCount: 10
      },
      rechargeDetail: {},
      confirmDialog: false,
      showDialog: false,
      undoReason: ''
    }
  },
  computed: {
    ...mapState('finance', [
      'manualRechargeList', 'systemAccountList'
    ]),
    ...mapState('setting', ['staffAllData']),
    enableSubmitButton() {
      return this.undoReason !== '' && this.undoReason.length <= 50
    },
    undoReasonRules() {
      if (this.undoReason === '') {
        return [this.$t('Views.Finance.noEmptyReason')]
      } else {
        return []
      }
    }
  },
  mounted() {
    const customerFilter = this.$route.query.customerFilter
    this.searchData[0].value = customerFilter
    this.form.customerFilter = customerFilter
    this.getPage()
    this.getStaff()
    this.getAccount()
  },
  methods: {
    ...mapActions('finance', [
      'getManualRechargeList',
      'undoRecharge',
      'getSystemAccountList'
    ]),
    ...mapActions('setting', ['getStaffAllData']),
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getManualRechargeList(this.form).then(() => {
        this.paginateConfig.total = this.manualRechargeList.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(
        () => {
          this.searchData[3].state = this.staffAllData.items
        }
      )
    },
    getAccount() {
      this.getSystemAccountList()
        .then(() => {
          this.searchData[2].state = this.systemAccountList.items.map(i => {
            i.name = ENUMS.systemAccountNames[i.name]
            return i
          })
        })
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      this.getPage(1)
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    handleSubmitDialog(type) {
      if (type === 'confirm') {
        const undoForm = {
          id: this.rechargeDetail.id,
          input: {
            undoReason: this.undoReason
          }
        }
        this.undoRecharge(undoForm)
          .then(() => {
            this.showDialog = false
            this.confirmDialog = false
            this.rechargeDetail = []
            this.$store.commit('app/setNotification', { msg: this.$t('Views.Finance.successCanceled'), type: 'success' })
            this.getPage()
            this.undoReason = ''
            this.$refs.undoReasonForm.resetValidation()
          })
          .catch((error) => {
            this.$store.commit('app/setNotification', { msg: error.error.message, type: 'error' })
          })
      } else {
        this.showDialog = true
      }
    },
    handleCloseDialog(type) {
      if (type === 'confirm') {
        this.showDialog = false
        this.undoReason = ''
        this.$refs.undoReasonForm.resetValidation()
      } else {
        this.confirmDialog = false
      }
    },
    getAccountName(name) {
      return ENUMS.systemAccountNames[name]
    }
  }
}
</script>

<style scoped>
.print-footer {
  font-size: 14px;
}
.print-footer > div {
  width:100%;
  margin-top:10px;
}
.print-item-title {
  width: 100px;
  display: inline-block;
  text-align: left;
  font-weight: bold;
  vertical-align: top;
  font-size: 14px;
  color: #515151;
}
.print-item-value {
  width: calc(calc(100% - 280px) / 2);
  display: inline-block;
  vertical-align: top;
  word-wrap: break-word;
  font-size: 14px;

}
.print-item-full-value {
   margin-left: 10px;
  width: calc(100% - 160px);
  display: inline-block;
  vertical-align: top;
  word-wrap: break-word;
  font-size: 14px;
}
.is-required {
  position: relative;
}
.is-required:before {
  content: "*";
  position: absolute;
  color: #f00;
  left: -10px;
  top: 16px;
}
</style>
